<template>
    <DetailedListItem
        v-if="design == 'detailed'"
        :item="item"
        :panelModalClass="resourceableModelClass"
        displayVariant="sidebar-listitem"
        :isToTheRight="isToTheRight"
    />

    <li v-else>
        <Link :href="item.url">
            <p
                class="font-normal line-clamp-1 text-gray-900 underline-hover"
                v-text="item.name"
            />
        </Link>
    </li>
</template>

<script>
import ModelImage from '@/Components/ModelComponents/ModelImage.vue'
import DetailedListItem from '@/Components/Panels/DetailedListItem.vue'

import { Link } from '@inertiajs/vue3'
import { PhDotOutline } from '@phosphor-icons/vue'

export default {
    name: 'ResourceListItem',

    components: {
        Link,
        PhDotOutline,
        ModelImage,
        DetailedListItem,
    },
    props: {
        resourceableModelClass: {
            type: String,
            required: true,
        },
        item: {
            required: true,
            type: Object,
            validator: (value) => {
                let keys = [
                    'name',
                    'created_at',
                    'url',
                    'type',
                    'type_id',
                    'modelClass',
                ]
                if (keys.some((key) => !Object.hasOwn(value, key))) {
                    console.warn(
                        `The list items is missing this key: ${keys.find(
                            (key) => !Object.hasOwn(value, key)
                        )}`
                    )
                    return false
                }
                return true
            },
        },
        design: {
            type: String,
            required: true,
        },
        isToTheRight: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        url() {
            if (!this.modelClass || !this.modelId) {
                return null
            }
            return this.$getModelUrl({
                modelClass: this.modelClass,
                id: this.modelId,
            })
        },
    },
}
</script>
